module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Create Your Project")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Project Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.project.title),
      callback: function($$v) {
        _vm.$set(_vm.project, "title", $$v)
      },
      expression: "project.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("File")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "required": ""
    },
    on: {
      "selected": _vm.onFileChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-277f3d1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/modals/create-project/create.vue
// module id = 639
// module chunks = 2